/* src/app/timeline-skip/modals/skip-round-new-modal/skip-round-new-modal.component.scss */
/*# sourceMappingURL=skip-round-new-modal.component.css.map */
